// Claude-style working statuses — the rotating one-word-ish verbs shown
// while the agent is between steps or grinding through a long one. One
// shared list so the working strip, the timeline's softened labels, and the
// bootstrap spinner all speak the same vocabulary.

const WORKING_STATUSES = [
  'Thinking',
  'Pondering',
  'Digging in',
  'Connecting the dots',
  'Pulling it together',
  'Double-checking',
] as const;

const ROTATE_EVERY_S = 6;

/** Status for the given elapsed time — rotates every few seconds so a long
 *  wait reads as alive, not frozen. Deterministic (elapsed-keyed), so any
 *  surface with the same clock shows the same word. */
export const workingStatusAt = (elapsedSec: number): string =>
  WORKING_STATUSES[
    Math.floor(Math.max(0, elapsedSec) / ROTATE_EVERY_S) %
      WORKING_STATUSES.length
  ];
